<script setup lang="ts">
import { type PropType } from 'vue'
import BaseIcon from '@/components/ui/icon/BaseIcon.vue'

export interface FlowStep {
	title: string
	description: string
	icon: string
	id?: string
}

defineProps({
	steps: {
		type: Array as PropType<FlowStep[]>,
		default: () => [],
	},
})
</script>

<template>
	<div class="flex flex-col mdp:flex-row">
		<div
			v-for="(step, index) in steps"
			:key="index"
			class="flex mdp:flex-1 mdp:flex-col"
			:id="step.id || undefined"
		>
			<div
				class="relative mr-strong-friends flex flex-col items-center mdp:mb-strong-friends mdp:mr-0"
			>
				<div
					class="typography-h5-str z-[1] grid h-[28px] w-[28px] flex-shrink-0 place-content-center rounded-full bg-o-500 text-white mdp:h-32px mdp:w-32px"
				>
					{{ index + 1 }}
				</div>

				<div
					v-show="index !== steps.length - 1"
					class="w-[1px] flex-1 bg-n-100 mdp:hidden"
				></div>

				<div
					v-show="index !== steps.length - 1"
					class="absolute left-1/2 top-1/2 hidden h-[1px] w-full -translate-y-1/2 bg-n-100 mdp:block"
				></div>
			</div>

			<div
				class="mr-8px space-y-8px pb-16px mdp:mr-0 mdp:px-12px mdp:pb-0 mdp:text-center lg:space-y-12px lg:px-24px"
			>
				<div class="typography-h5-str text-n-800">
					{{ step.title }}
				</div>
				<div class="typography-b2-reg text-n-500">
					{{ step.description }}
				</div>
			</div>

			<BaseIcon
				:name="step.icon"
				class="ml-auto h-[75px] w-[100px] flex-shrink-0 mdp:order-first mdp:mx-auto mdp:mb-close-ish-friends mdp:h-[120px] mdp:w-[160px]"
			/>
		</div>
	</div>
</template>
